import { Box, Dialog } from '@mui/material';
import {
  addDays,
  endOfMonth,
  endOfWeek,
  format,
  isSameDay,
  isSameMonth,
  startOfMonth,
  startOfWeek,
} from 'date-fns';
import { ru, uz } from 'date-fns/locale';
import { FC, ReactNode, useState } from 'react';
// import i18n from '../../app/i18n';
import { useTranslation } from 'react-i18next';
import { useDialog } from 'src/hooks';
import { AttestationsEditDialog, AttestationsInfoDialog } from '../attestations';
import CalendarCell from './CalendarCell';

interface CalendarCellsProps {
  month: Date;
  onDayClick: (day: string) => void;
  data: any;
  refetch: () => void;
}

const CalendarCells: FC<CalendarCellsProps> = ({ month, onDayClick, data, refetch }) => {
  const monthStart = startOfMonth(month);
  const monthEnd = endOfMonth(monthStart);
  const startDate = startOfWeek(monthStart, { weekStartsOn: 1 });
  const endDate = endOfWeek(monthEnd, { weekStartsOn: 1 });
  const { t, i18n } = useTranslation();
  const [openDialog, setOpenDialog] = useState(false);
  const [dialogContent, setDialogContent] = useState<ReactNode>(null);

  const [openAttestationsEdit, closeAttestationsEdit] = useDialog(AttestationsEditDialog);
  const [openAttestationsInfo, closeAttestationsInfo] = useDialog(AttestationsInfoDialog);

  let days = [];
  let day = startDate;

  let weekDaysLabels = [];

  const getNotesByDay = (day: Date) => {
    return data.filter((event: any) => isSameDay(new Date(event.start), day));
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setDialogContent(null);
  };

  const handleOpenEvent = (event: any) => {
    if (!event) return;

    openAttestationsInfo({
      id: event.id,
      onEdit: (id: string) => {
        closeAttestationsInfo();

        openAttestationsEdit({
          title: t('attestations.add', 'Редактировать расписание'),
          id,
          onSubmit: () => {
            closeAttestationsEdit();
            refetch();
          },
        });
      },
    });
  };

  for (let i = 0; i < 7; i++) {
    weekDaysLabels.push(
      <Box py={1.5} width={40} height={40} textAlign="center" color="light.600" key={i}>
        {format(addDays(day, i), 'iiiiii', { locale: i18n.language === 'ru' ? ru : uz })}
      </Box>
    );
  }

  while (day <= endDate) {
    days.push(
      <CalendarCell
        day={day}
        currentMonth={isSameMonth(day, month)}
        events={getNotesByDay(day)}
        onClick={onDayClick}
        onEventClick={handleOpenEvent}
        // openEventForm={handleOpenEventForm}
        onClose={handleCloseDialog}
        key={day.toString()}
      />
    );
    day = addDays(day, 1);
  }

  return (
    <>
      <Box display="grid" gridTemplateColumns="repeat(7, 1fr)" gap={0.25}>
        {days}
      </Box>
      <Dialog open={openDialog} onClose={handleCloseDialog}>
        {dialogContent}
      </Dialog>
    </>
  );
};

export default CalendarCells;
